/**
 * Warn when Flagsmith fails to fetch flags. This is expected when the user is offline or blocking the Flagsmith
 * domain (adblockers, VPNs etc.) and must not crash the application: default flag values are used instead.
 * @param {Error} error - The error thrown by Flagsmith.
 */
export const warnOnError = (error: Error) => {
    console.warn("Failed to fetch feature flags. Default flag values will be used.", error);
};
